import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { fetchTopicNetwork } from '../api/networkClient'
import type { NetworkRange } from '../model/contracts'

const VALID_RANGES: NetworkRange[] = ['7d', '30d', '90d', 'all']

function isValidRange(value: string | null): value is NetworkRange {
  return VALID_RANGES.includes(value as NetworkRange)
}

export function useTopicNetwork(topicId: string) {
  const [searchParams, setSearchParams] = useSearchParams()
  const rawRange = searchParams.get('range')
  const range: NetworkRange = isValidRange(rawRange) ? rawRange : '7d'

  const { data, isLoading, error } = useQuery({
    queryKey: ['network', topicId, range],
    queryFn: ({ signal }) => fetchTopicNetwork(topicId, range, signal),
    staleTime: 60_000,
    enabled: Boolean(topicId),
  })

  function setRange(next: NetworkRange) {
    setSearchParams((prev) => {
      const updated = new URLSearchParams(prev)
      updated.set('range', next)
      return updated
    })
  }

  return { data, isLoading, error, range, setRange }
}
